import { render, staticRenderFns } from "./ErrorsModal.vue?vue&type=template&id=1340ff4a&scoped=true"
import script from "./ErrorsModal.vue?vue&type=script&lang=js"
export * from "./ErrorsModal.vue?vue&type=script&lang=js"
import style0 from "./ErrorsModal.vue?vue&type=style&index=0&id=1340ff4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1340ff4a",
  null
  
)

export default component.exports